import initialState from 'store/initialState';
import {ActionTypes, AppActionTypes } from './types';

export default function appReducer(state = initialState.app, action: AppActionTypes) {
  switch (action.type) {
    case ActionTypes.APP_LOADED:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true
      });
    case ActionTypes.APP_LOADING_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        isLoadingFailed: true
      });
    case ActionTypes.APP_RESOLUTION_CHANGED:
      return Object.assign({}, state, {
        ...action.payload
      });
    default:
      return state;
  }
}
